module.exports = __webpack_public_path__ + "static/media/NA.9c6fadc1.svg";